import {AgentPreferences, defaultPrefs} from "../util/defaultPrefs.tsx";

export const defaultInspectorPrefs: AgentPreferences = {
    ...defaultPrefs,
    inspectionTierColors: [
        {tier: "NOTHING", color: "primary", watched: true},
        {tier: "SURCHARGE", color: "neutral", watched: false},
    ],
};



